import React, { FC } from 'react';
type OnlineStatusType = {
  online: boolean;
  small?: boolean;
};
const OnlineStatus: FC<OnlineStatusType> = ({ online, small }) => {
  return (
    <span
      className={`py-1 font-medium mt-[1.5px] border ${
        online
          ? ' text-[#73D260] bg-[#F1FAEF] border-[#73D260]'
          : 'text-[#AB0720] bg-[#FEF0F2] border-[#F73B58]'
      } ${small ? 'px-3 text-xs' : 'px-4'} rounded`}>
      {online ? 'Online' : 'Offline'}
    </span>
  );
};

export default OnlineStatus;
